import React from 'react';
import "../ProposalPreparation/ProposalPreparation.css"


const SectionsWritingLoader = ({ currentStep, sectionNames }) => {
  
  const steps = sectionNames.map((section) => `${section} Yazılıyor`);
  
  const progress = (Math.max(0, currentStep))/(steps.length-1)*100;
  return (
    <div>
        <div className="progress-window">
            <div className="progress-details">

                <div className="progress-text">
                    <h3>{steps[currentStep]}</h3>
                </div>
                <p style={{ color: '#003c96', fontSize: "14px", justifySelf: "center"}}>Tahmini Kalan Bekleme Süresi: {((100-progress.toFixed(0))/100*50).toFixed(0)} dakika</p>
                
                <progress value={progress} max="100" min="0" className="progress-bar"></progress>

                <p style={{ color: '#003c96', fontSize: "16px" }}> %{progress.toFixed(0)} Tamamlandı</p>
            </div>
        </div>
   
    </div>
  );
};

export default SectionsWritingLoader;